import React, { useState } from 'react';
import Navbar from './components/Navbar';
import BlueprintBg from './components/BlueprintBg';
import MarketPage from './pages/MarketPage';
import DetailPage from './pages/DetailPage';
import PortfolioPage from './pages/PortfolioPage';
import PricingPage from './pages/PricingPage';
import AboutPage from './pages/AboutPage';
import AppraisalPage from './pages/AppraisalPage';

export default function App() {
  const [page, setPage] = useState('market');
  const [selectedWatch, setSelectedWatch] = useState(null);

  function handleSelectWatch(watch) {
    setSelectedWatch(watch);
    setPage('detail');
    window.scrollTo(0, 0);
  }

  function handleSetPage(p) {
    setSelectedWatch(null);
    setPage(p);
    window.scrollTo(0, 0);
  }

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', position: 'relative' }}>
      <BlueprintBg />
      <Navbar page={page} setPage={handleSetPage} />

      {page === 'market'    && <MarketPage onSelectWatch={handleSelectWatch} />}
      {page === 'appraisal' && <AppraisalPage onSelectWatch={handleSelectWatch} />}
      {page === 'detail'    && selectedWatch && <DetailPage watch={selectedWatch} onBack={() => handleSetPage('market')} />}
      {page === 'portfolio' && <PortfolioPage onSelectWatch={handleSelectWatch} />}
      {page === 'pricing'   && <PricingPage />}
      {page === 'about'     && <AboutPage />}

      <footer style={{
        borderTop: '0.5px solid var(--border)', padding: '20px 28px',
        display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap',
        gap: 8, background: 'var(--surface)', marginTop: 40,
      }}>
        <span style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 13, fontWeight: 600, letterSpacing: '0.05em' }}>
          <span style={{ color: '#C0392B' }}>DIAL</span>
          <span style={{ color: 'var(--text3)', fontWeight: 300 }}> MARKET</span>
        </span>
        <span style={{ fontSize: 12, color: 'var(--text3)' }}>Valuations are estimates — not a certified appraisal</span>
      </footer>
    </div>
  );
}
